import styled from 'styled-components';

export const FormGroup = styled.div`
  align-items: center;
  display: grid;
  grid-column-gap: 4px;
  grid-row-gap: 4px;
  grid-template-columns: 130px 1fr;
  padding-bottom: 4px;
`;

export const DateFormGroup = styled.div`
  align-items: center;
  display: grid;
  grid-column-gap: 4px;
  grid-row-gap: 4px;
  grid-template-columns: 130px 1fr 1fr;
`;

export const CheckboxGroup = styled.div`
  align-items: center;
  display: grid;
  grid-column-gap: 4px;
  grid-row-gap: 16px;
  grid-template-columns: 24px 1fr 24px 1fr;
  padding-top: 24px;
`;
